import { createMultiSelectOptionSetValueFromOptionGuid, FieldsToLookupByMasterAttributeId, friendlyTValue } from "global/Application";
import {
    IBenefit as FAM_IBenefit,
    IGroupConfigurationConfig as FAM_IGroupConfigurationConfig,
    IGroupConfigurationData as FAM_IGroupConfigurationData
} from "model/FlexibleAttributeModel";
import { v4 as uuidv4 } from 'uuid';
import { Memoize } from "../Utility/TSFunctions";
import { BaseJsonTransformer } from "./IJsonTransformer";
import { $oset_$myhealthnovel_multiselect_$behavioral_health_id, $oset_$myhealthnovel_multiselect_$digestive_health_id, $oset_$myhealthnovel_multiselect_$musculoskeletal_id, $oset_$myhealthnovel_multiselect_$no_id, $oset_$myhealthnovel_multiselect_$tobacco_cessation_id, $oset_$myhealthnovel_multiselect_$weight_management_program_id, $oset_$myhealthnovel_multiselect_$women_s_health_id, $oset_$nia_programs_$hips_knees_and_shoulders_and_musculoskeletal_care_id, $oset_$nia_programs_$hips_knees_and_shoulders_and_radiation_oncology_id, $oset_$nia_programs_$hips_knees_and_shoulders_and_radiology_management_id, $oset_$nia_programs_$hips_knees_and_shoulders_id, $oset_$nia_programs_$hips_knees_and_shoulders_musculoskeletal_care_and_radiation_oncology_id, $oset_$nia_programs_$hips_knees_and_shoulders_musculoskeletal_care_and_radiology_management_id, $oset_$nia_programs_$hips_knees_and_shoulders_musculoskeletal_care_radiation_oncology_and_radiology_management_id, $oset_$nia_programs_$musculoskeletal_care_and_radiation_oncology_id, $oset_$nia_programs_$musculoskeletal_care_and_radiology_management_id, $oset_$nia_programs_$musculoskeletal_care_id, $oset_$nia_programs_$musculoskeletal_care_radiation_oncology_and_radiology_management_id, $oset_$nia_programs_$no_id, $oset_$nia_programs_$radiation_oncology_and_radiology_management_id, $oset_$nia_programs_$radiation_oncology_id, $oset_$nia_programs_$radiology_management_id, $oset_$nia_programs_ms_$hips_knees_and_shoulders_id, $oset_$nia_programs_ms_$musculoskeletal_care_id, $oset_$nia_programs_ms_$no_id, $oset_$nia_programs_ms_$radiation_oncology_id, $oset_$nia_programs_ms_$radiology_management_id } from "model/ConfigOptionSetConstants";
import { $matt_$ancillary_$bcbs_myhealthnovel_id, $matt_$ancillary_$bcbs_myhealthnovelid_id, $matt_$ancillary_$bcbs_nia_programs_id, $matt_$ancillary_$bcbs_nia_programs_ms_id } from "model/MasterAttributeConstants";

interface IMapping {

    [key: string]: {
        description: string;
        categories: {
            id: string;
            description: string;
        }[];
    };
}

/**
 * Transformers:
 * Moved from Sprint34Transformer.ts
 * MHTK And NIA programs transformer - old optionset to multi select fields
 * https://dev.azure.com/blue-infosys/Group%20Library/_sprints/taskboard/Group%20Library%20Team/Group%20Library/Sprint%2032?workitem=488342
 */
export class Sprint33PatchTransformer extends BaseJsonTransformer {
    config: FAM_IGroupConfigurationConfig;
    json: FAM_IGroupConfigurationData;

    addNotificationNIAMultiSelect: boolean = false;

    constructor({ config, json }: { config: FAM_IGroupConfigurationConfig, json: FAM_IGroupConfigurationData }) {
        super();
        this.config = config;

        this.json = json;

    }

    MHTKMapping() {

        // Define a mapping object
        const myHealthNovelGuidMappings: { [key: string]: string } = {
            "Weight Management Program": $oset_$myhealthnovel_multiselect_$weight_management_program_id,
            "Behavioral Health": $oset_$myhealthnovel_multiselect_$behavioral_health_id,
            "Digestive Health": $oset_$myhealthnovel_multiselect_$digestive_health_id,
            "Musculoskeletal": $oset_$myhealthnovel_multiselect_$musculoskeletal_id,
            "No": $oset_$myhealthnovel_multiselect_$no_id,
            "Tobacco Cessation": $oset_$myhealthnovel_multiselect_$tobacco_cessation_id,
            "Women's Health": $oset_$myhealthnovel_multiselect_$women_s_health_id
        };

        const myHealthNovelValueMappings: { [key: string]: number } = {
            "Weight Management Program": 10,
            "Behavioral Health": 20,
            "Digestive Health": 30,
            "Musculoskeletal": 40,
            "No": 50,
            "Tobacco Cessation": 60,
            "Women's Health": 70
        };

        // Define a mapping object
        const niaGuidMappings: IMapping =
        {
            [$oset_$nia_programs_$hips_knees_and_shoulders_id]: {
                "description": "Hips Knees and Shoulders",
                "categories": [
                    {
                        "id": $oset_$nia_programs_ms_$hips_knees_and_shoulders_id,
                        "description": "Hips Knees and Shoulders"
                    }
                ]
            },
            [$oset_$nia_programs_$hips_knees_and_shoulders_and_musculoskeletal_care_id]: {
                "description": "Hips Knees and Shoulders and Musculoskeletal Care",
                "categories": [
                    {
                        "id": $oset_$nia_programs_ms_$hips_knees_and_shoulders_id,
                        "description": "Hips Knees and Shoulders"
                    },
                    {
                        "id": $oset_$nia_programs_ms_$musculoskeletal_care_id,
                        "description": "Musculoskeletal Care"
                    }
                ]
            },
            [$oset_$nia_programs_$hips_knees_and_shoulders_and_radiation_oncology_id]: {
                "description": "Hips Knees and Shoulders and Radiation Oncology",
                "categories": [
                    {
                        "id": $oset_$nia_programs_ms_$hips_knees_and_shoulders_id,
                        "description": "Hips Knees and Shoulders"
                    },
                    {
                        "id": $oset_$nia_programs_ms_$radiation_oncology_id,
                        "description": "Radiation Oncology"
                    }
                ]
            },
            [$oset_$nia_programs_$hips_knees_and_shoulders_and_radiology_management_id]: {
                "description": "Hips Knees and Shoulders and Radiology Management",
                "categories": [
                    {
                        "id": $oset_$nia_programs_ms_$hips_knees_and_shoulders_id,
                        "description": "Hips Knees and Shoulders"
                    },
                    {
                        "id": $oset_$nia_programs_ms_$radiology_management_id,
                        "description": "Radiology Management"
                    }
                ]
            },
            [$oset_$nia_programs_$hips_knees_and_shoulders_musculoskeletal_care_and_radiation_oncology_id]: {
                "description": "Hips Knees and Shoulders, Musculoskeletal Care and Radiation Oncology",
                "categories": [
                    {
                        "id": $oset_$nia_programs_ms_$hips_knees_and_shoulders_id,
                        "description": "Hips Knees and Shoulders"
                    },
                    {
                        "id": $oset_$nia_programs_ms_$musculoskeletal_care_id,
                        "description": "Musculoskeletal Care"
                    },
                    {
                        "id": $oset_$nia_programs_ms_$radiation_oncology_id,
                        "description": "Radiation Oncology"
                    }
                ]
            },
            [$oset_$nia_programs_$hips_knees_and_shoulders_musculoskeletal_care_radiation_oncology_and_radiology_management_id]: {
                "description": "Hips Knees and Shoulders, Musculoskeletal Care, Radiation Oncology and Radiology Management",
                "categories": [
                    {
                        "id": $oset_$nia_programs_ms_$hips_knees_and_shoulders_id,
                        "description": "Hips Knees and Shoulders"
                    },
                    {
                        "id": $oset_$nia_programs_ms_$musculoskeletal_care_id,
                        "description": "Musculoskeletal Care"
                    },
                    {
                        "id": $oset_$nia_programs_ms_$radiation_oncology_id,
                        "description": "Radiation Oncology"
                    },
                    {
                        "id": $oset_$nia_programs_ms_$radiology_management_id,
                        "description": "Radiology Management"
                    }
                ]
            },
            [$oset_$nia_programs_$no_id]: {
                "description": "No",
                "categories": [
                    {
                        "id": $oset_$nia_programs_ms_$no_id,
                        "description": "No"
                    }
                ]
            },
            [$oset_$nia_programs_$musculoskeletal_care_id]: {
                "description": "Musculoskeletal Care",
                "categories": [
                    {
                        "id": $oset_$nia_programs_ms_$musculoskeletal_care_id,
                        "description": "Musculoskeletal Care"
                    }
                ]
            },
            [$oset_$nia_programs_$radiation_oncology_id]: {
                "description": "Radiation Oncology",
                "categories": [
                    {
                        "id": $oset_$nia_programs_ms_$radiation_oncology_id,
                        "description": "Radiation Oncology"
                    }
                ]
            },
            [$oset_$nia_programs_$radiology_management_id]: {
                "description": "Radiology Management",
                "categories": [
                    {
                        "id": $oset_$nia_programs_ms_$radiology_management_id,
                        "description": "Radiology Management"
                    }
                ]
            },
            [$oset_$nia_programs_$musculoskeletal_care_and_radiology_management_id]: {
                "description": "Musculoskeletal Care and Radiology Management",
                "categories": [
                    {
                        "id": $oset_$nia_programs_ms_$musculoskeletal_care_id,
                        "description": "Musculoskeletal Care"
                    },
                    {
                        "id": $oset_$nia_programs_ms_$radiology_management_id,
                        "description": "Radiology Management"
                    }
                ]
            },
            [$oset_$nia_programs_$musculoskeletal_care_and_radiation_oncology_id]: {
                "description": "Musculoskeletal Care and Radiation Oncology",
                "categories": [
                    {
                        "id": $oset_$nia_programs_ms_$musculoskeletal_care_id,
                        "description": "Musculoskeletal Care"
                    },
                    {
                        "id": $oset_$nia_programs_ms_$radiation_oncology_id,
                        "description": "Radiation Oncology"
                    }
                ]
            },
            [$oset_$nia_programs_$radiation_oncology_and_radiology_management_id]: {
                "description": "Radiation Oncology and Radiology Management",
                "categories": [
                    {
                        "id": $oset_$nia_programs_ms_$radiation_oncology_id,
                        "description": "Radiation Oncology"
                    },
                    {
                        "id": $oset_$nia_programs_ms_$radiology_management_id,
                        "description": "Radiology Management"
                    }
                ]
            },
            [$oset_$nia_programs_$musculoskeletal_care_radiation_oncology_and_radiology_management_id]: {
                "description": "Musculoskeletal Care, Radiation Oncology and Radiology Management",
                "categories": [
                    {
                        "id": $oset_$nia_programs_ms_$musculoskeletal_care_id,
                        "description": "Musculoskeletal Care"
                    },
                    {
                        "id": $oset_$nia_programs_ms_$radiation_oncology_id,
                        "description": "Radiation Oncology"
                    },
                    {
                        "id": $oset_$nia_programs_ms_$radiology_management_id,
                        "description": "Radiology Management"
                    }
                ]
            },
            [$oset_$nia_programs_$hips_knees_and_shoulders_musculoskeletal_care_and_radiology_management_id]: {
                "description": "Hips Knees and Shoulders, Musculoskeletal Care and Radiology Management",
                "categories": [
                    {
                        "id": $oset_$nia_programs_ms_$hips_knees_and_shoulders_id,
                        "description": "Hips Knees and Shoulders"
                    },
                    {
                        "id": $oset_$nia_programs_ms_$musculoskeletal_care_id,
                        "description": "Musculoskeletal Care"
                    },
                    {
                        "id": $oset_$nia_programs_ms_$radiology_management_id,
                        "description": "Radiology Management"
                    }
                ]
            }
        };

        const niaValueMappings: { [key: string]: number } = {
            "Hips Knees and Shoulders": 10,
            "Musculoskeletal Care": 20,
            "No": 50,
            "Radiation Oncology": 30,
            "Radiology Management": 40
        };
        return {
            myHealthNovelGuidMappings,
            myHealthNovelValueMappings,
            niaGuidMappings,
            niaValueMappings
        }
    }

    async before(json: FAM_IGroupConfigurationData): Promise<void> {

    }

    async transformBenefit(benefit: FAM_IBenefit): Promise<boolean | void> {

        const categories = this.config.cache.map_bcbs_config_category_named;

        // cache list of fields upon first call
        const fieldInfosMemoized = Memoize(() => {
            return FieldsToLookupByMasterAttributeId(this.config, benefit.fields);
        });

        // --------------------------------------------------------------------------------------------
        // is Ancillary benefit?
        if (benefit.bcbs_config_categoryid === this.config.cache.map_bcbs_config_category_named['Ancillary'].bcbs_config_categoryid) {

            // map to array of master attributes, first element in array being the visible one.
            const fieldsByMasterAttrId = fieldInfosMemoized();

            //myHealthNovel - optionSet (original)
            //https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=818b0bc2-a215-ed11-b83c-00224820a835&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=1998f1ab-3d58-ec11-8f8f-000d3a597a8a
            const bcbs_myhealthnovel_masterAttribute_old = fieldsByMasterAttrId[$matt_$ancillary_$bcbs_myhealthnovelid_id]
            const bcbs_myhealthnovel_old = bcbs_myhealthnovel_masterAttribute_old[0];

            //MyHealthNovel - multiselect
            //https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=1a953404-1354-ef11-a317-000d3a17460e            
            const bcbs_myhealthnovel_masterAttribute = fieldsByMasterAttrId[$matt_$ancillary_$bcbs_myhealthnovel_id]
            const bcbs_myhealthnovel = bcbs_myhealthnovel_masterAttribute[0];

            //NIA Programs - OptionSet
            //https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=818b0bc2-a215-ed11-b83c-00224820a835&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=2598f1ab-3d58-ec11-8f8f-000d3a597a8a
            const bcbs_niaPrograms_masterattribiute_old = fieldsByMasterAttrId[$matt_$ancillary_$bcbs_nia_programs_id]
            const bcbs_niaprograms_old = bcbs_niaPrograms_masterattribiute_old[0];

            //NIA Programs - multiSelect
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=818b0bc2-a215-ed11-b83c-00224820a835&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=0803c40e-1754-ef11-a317-000d3a17460e
            const bcbs_niaPrograms_masterattribiute = fieldsByMasterAttrId[$matt_$ancillary_$bcbs_nia_programs_ms_id]
            const bcbs_niaprograms = bcbs_niaPrograms_masterattribiute[0];

            // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/516942
            // update new field if the old field is populated
            if (bcbs_myhealthnovel_old) {

                //if old field exists and new field does not have a value, get the value
                const value_bcbs_myhealthnovel_old = bcbs_myhealthnovel_old.field.values[0];
                const value_bcbs_myhealthnovel = bcbs_myhealthnovel.field.values[0];
                //need to parse out the values from the old optionset
                if (value_bcbs_myhealthnovel_old.value && !value_bcbs_myhealthnovel.value) {
                    const stringValue_myhealthnovel = friendlyTValue(value_bcbs_myhealthnovel_old.value);
                    var listOfMyHealthNovelValues = stringValue_myhealthnovel.split(' + ');

                    var listOfGuids: string[] = [];
                    //build list of guids
                    listOfMyHealthNovelValues.forEach(mhnValue => {
                        if (this.MHTKMapping().myHealthNovelGuidMappings[mhnValue] !== undefined) {
                            listOfGuids.push(this.MHTKMapping().myHealthNovelGuidMappings[mhnValue]);
                        }
                    });

                    bcbs_myhealthnovel.field.values[0].value = createMultiSelectOptionSetValueFromOptionGuid(this.config, listOfGuids);
                }
            }

            if (bcbs_niaprograms_old) {

                //if old field exists and new field does not have a value, get the value
                const value_nia_oldID = bcbs_niaprograms_old.field.values[0].value?.type === "entity" ? bcbs_niaprograms_old.field.values[0].value.id : "";
                const value_bcbs_nia = bcbs_niaprograms.field.values[0];
                if (value_nia_oldID && !value_bcbs_nia.value) {
                    //need to parse out the values from the old optionset
                    var listOfNIAValues = this.MHTKMapping().niaGuidMappings[value_nia_oldID];

                    var listOfGuids: string[] = [];
                    //build list of guids
                    listOfNIAValues.categories.forEach(niaCategory => {
                        listOfGuids.push(niaCategory.id);
                    });

                    bcbs_niaprograms.field.values[0].value = createMultiSelectOptionSetValueFromOptionGuid(this.config, listOfGuids);
                }
            }

            //option set -> carrier lookup transformer 
        }
    }

    async after(json: FAM_IGroupConfigurationData): Promise<void> {

        console.debug("[tran] Sprint33PatchTransformer.after")

        if (!json.transformers)
            json.transformers = {};

        json.transformers.Sprint33PatchTransformer = true

    }
}
